import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AppConfirmDialogComponent } from './app-confirm-dialog.component';
import { AppAlertDialogComponent } from './app-alert-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppConfirmDialogComponent, AppAlertDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, FormsModule],
})
export class AppDialogModule {}

